import * as actionTypes from "./actionTypes";
import {fetchGetTorresowo} from "../../utils/utils";

export const fetchEpisode = (serieId, seasonNumber, episodeNumber, uid) => dispatch => {
    fetchGetTorresowo(`/tmdb/serie/${serieId}/season/${seasonNumber}/episode/${episodeNumber}?uid=${uid}`).then(episode => {
        dispatch(updateSelectedEpisode(episode));
    });
}

export const fetchMovie = (movieId, uid) => dispatch => {
    fetchGetTorresowo(`/tmdb/movie/${movieId}?uid=${uid}`).then(movie => {
        dispatch(updateSelectedEpisode(movie));
    });
}

export const fetchSerie = (serieId, uid) => dispatch => {
    fetchGetTorresowo(`/tmdb/serie/${serieId}?uid=${uid}`).then(serie => {
        dispatch(updateSelectedSerie({...serie, seasons: serie.seasons.filter(s => s.season_number > 0)}));
    });
}

export const fetchSeason = (serieId, seasonNumber, uid) => dispatch => {
    fetchGetTorresowo('/tmdb/serie/' + serieId + '/season/' + seasonNumber + '?uid=' + uid).then(data => {
        dispatch(updateSelectedSeason(data));
    })
}

export const clearSelectedSerie = () => ({
    type: actionTypes.UPDATE_SELECTED_SERIE,
    serie: null
})


export const clearSelectedSeason = () => ({
    type: actionTypes.UPDATE_SELECTED_SEASON,
    season: null
})

export const clearSelectedEpisode = () => ({
    type: actionTypes.UPDATE_SELECTED_EPISODE,
    episode: null
})

export const updateViewEpisode = (view, episode) => ({
    type: actionTypes.UPDATE_VIEW_EPISODE,
    view, episode
})

export const updateSelectedEpisode = (episode) => ({
    type: actionTypes.UPDATE_SELECTED_EPISODE,
    episode
})

export const updateSelectedSeason = (season) => ({
    type: actionTypes.UPDATE_SELECTED_SEASON,
    season
})

export const updateSelectedSerie = (serie) => ({
    type: actionTypes.UPDATE_SELECTED_SERIE,
    serie
})
